define(
    'viewmodels/secured/uploads/upload',[
        "viewmodels/ViewModelNotification",
        "plugins/router",
        "viewmodels/secured/uploads/context",
        "i19n!i19n/strings"    
    ],
    function (ViewModelNotification, router, ctx, i19n) {
        var grid = null;
        var $grid = null;

        var vm = new ViewModelNotification(
        {
            i19n: i19n,
            
            lastdays: ko.observable(30),
            mode: ko.observable(""),
            title: ko.observable(""),
            subtitle: ko.observable(""),
            isGuest: ko.observable(false),
            isUser: ko.observable(false),
            isAdmin: ko.observable(false),
            isInstanceAdmin: ko.observable(false)
        });

        vm.activate = function (mode) {
            vm.isGuest(vm.session.role == 0 || vm.session.role == 1 ? true : false);
            vm.isUser(vm.session.role == 2);
            vm.isAdmin(vm.session.role == 3);
            vm.isInstanceAdmin(vm.session.role == 4);

            vm.mode(mode);
            vm.title(mode == "my" ? i19n.to.myuploadrequests : i19n.to.alluploadrequests);
            vm.subtitle(i19n.to.documentuploadrequests);

            if (grid) {
                if (vm.mode() == "my") {
                    grid.hideColumn("sharedBy");
                } else {
                    grid.showColumn("sharedBy");
                }

                grid.dataSource.read();                
            }
        };
        vm.attached = function () {
            $grid = $("#main-" + vm.mode() + "upload-request-grid");

            buildKendoGrid();

            function buildKendoGrid() {
                var columns = [
                    { field: "folderShareId", hidden: true, attributes: { class: "get-value" } },
                    { field: "createdDate", title: i19n.to.uploadrequestdate, width: 160, format: "{0:g}" }, //d MMM yyyy hh:mm tt
                    { field: "sharedBy", title: i19n.to.requestedby, width: 150, name: "sharedBy", hidden: vm.mode() == "my" },
                    { field: "folderDisplayName", title: i19n.to.folder },
                    { field: "recipientCount", title: i19n.to.recipients, width: 100 },
                    { field: "uploadloadCount", title: i19n.to.uploads, width: 100 },
                    { field: "expiry", title: i19n.to.uploadexpiry, width: 150, attributes: { "class": "expiry" }, format: "{0:g}" }, //d MMM yyyy hh:mm tt
                    {
                        command: [{ name: "viewdetails", text: i19n.to.viewdetails, click: showDetails },
                                  { name: "canceldetails", text: '<i class="k-icon k-delete"></i>' +i19n.to.cancel, click: cancelDetailClick }]
                                , title: "", width: 200
                    }];                

                grid = $grid.kendoGrid({
                    excel: {
                        allPages: true,
                        fileName: "upload-request.xlsx"
                    },
                    dataSource: getKendoGridDataSource(),
                    resizable: true,
                    reorderable: true,
                    sortable: true,
                    columns: columns,
                    scrollable: {
                        virtual: true
                    }
                }).data("kendoGrid");

                function showDetails(e) {
                    e.preventDefault();

                    var row = this.dataItem($(e.currentTarget).closest("tr"));

                    var expiryInfo = "";

                    try {
                        expiryInfo = "Upload Request Date " + kendo.toString(row.createdDate, "g"); //d MMMM h:mm tt
                    } catch (ex) { }

                    try {
                        if (row.expiry != "No Expiry") {
                            expiryInfo = expiryInfo + ", Upload Expiry " + kendo.toString(new Date(row.expiryDate), "g"); //d MMMM h:mm tt
                        } else {
                            expiryInfo = expiryInfo + ", No Expiry";
                        }
                    } catch (ex) { }

                    sessionStorage.removeItem("upload-request-expiry-info");
                    sessionStorage.removeItem("upload-request-id");
                    sessionStorage.removeItem("upload-request-folder-name");

                    sessionStorage.setItem("upload-request-expiry-info", expiryInfo);
                    sessionStorage.setItem("upload-request-id", row.folderShareId);                    
                    sessionStorage.setItem("upload-request-folder-name", row.folderDisplayName);

                    router.navigate("uploaddetails/" + vm.mode());
                };
                function cancelDetailClick(e) {
                    e.preventDefault();

                    //var dataItem = this.dataItem($(e.currentTarget).closest("tr"));
                    var txtItem = $(e.currentTarget).closest("tr").find(".get-value").text();

                    ctx.cancelForUploadRequest(txtItem);

                    grid.dataSource.read();
                }
            };
            function getKendoGridDataSource() {
                var schema = {
                    model: {
                        folderShareId: "folderShareId",
                        fields: {
                            folderShareId: { type: "string" },
                            createdDate: { type: "date" },
                            expiry: { type: "string" }
                        }
                    }
                };

                return new kendo.data.DataSource({
                    transport: {
                        read: function (callbacks) {
                            ctx.loadForUploadRequests(vm.lastdays(), vm.mode() == "my")
                            .done(function (data) {
                                data = _.sortBy(data, function (itm) { return itm.createdDate; }).reverse();

                                callbacks.success(data);

                                setTimeout(function () {
                                    resizeGrid();
                                }, 500);
                            })
                            .fail(function (e) {
                                console.error(e);
                            });
                        }
                    },
                    schema: schema,
                    pageSize: 999
                });
            };                        

            $("#showall").on("click", function (e) {
                e.preventDefault();

                $(this).parent().addClass("active");
                $("#last30").parent().removeClass();
                $("#last90").parent().removeClass();

                vm.lastdays(11000);

                grid.dataSource.read();
            });
            $("#last30").on("click", function (e) {
                e.preventDefault();

                $(this).parent().addClass("active");
                $("#showall").parent().removeClass();
                $("#last90").parent().removeClass();

                vm.lastdays(30);

                grid.dataSource.read();
            });
            $("#last90").on("click", function (e) {
                e.preventDefault();

                $(this).parent().addClass("active");
                $("#showall").parent().removeClass();
                $("#last30").parent().removeClass();

                vm.lastdays(90);

                grid.dataSource.read();
            });

            $(window).on("resize", _.debounce(resizeGrid, 250));
        };

        vm.close = function () {
            if (sessionStorage.__url) {
                window.location.href = sessionStorage.__url;
            } else {
                router.navigate("explorer");
            }
            //router.navigate("explorer");
        };
        vm.mySharesClick = function () {
            router.navigate("uploads/my");
        };
        vm.allSharesClick = function () {
            router.navigate("uploads/all");
        };
        vm.exportToExcel = ko.asyncCommand({
            canExecute: function (isExecuting) {
                return !isExecuting;
            },
            execute: function (complete) {
                grid.saveAsExcel();

                complete();
            }
        });

        return vm;

        function resizeGrid() {
            if (!$grid)
                return;

            var newGridHeight = $("#upload-request-content").outerHeight()
                - $(".page-header", "#upload-request-content").outerHeight()
                - 150;

            $grid.height(newGridHeight);

            grid.resize();
        }
    }
 );
